<ng-container *ngIf="showModal">
	<app-mobile-kamona-message-widget
		[title]="msgTitle"
		[iconType]="iconType"
		[btnText]="btnText"
		[btnType]="btnType"
		(emitCancel)="handleCloseModal()"
		[suspensionReleaseTimeEpoch]="suspensionReleaseTimeEpoch"
		[description]="msgDescription">
	</app-mobile-kamona-message-widget>
</ng-container>


<ng-container [ngSwitch]="currentStep">
	<ng-container *ngSwitchDefault>
		<ng-container *ngTemplateOutlet="stepOne"></ng-container>
	</ng-container>
	<ng-container *ngSwitchCase="PasscodeRecoveryStep.PHONE_VERIFICATION">
		<ng-container *ngTemplateOutlet="idVerification"></ng-container>
	</ng-container>
  <ng-container *ngIf="verificationType === AuthenticationType.TWO_FACTOR_AUTHENTICATION">
    <ng-container *ngSwitchCase="PasscodeRecoveryStep.LIVELINESS">
      <ng-container *ngTemplateOutlet="liveliness"></ng-container>
    </ng-container>
  </ng-container>
	<ng-container *ngSwitchCase="PasscodeRecoveryStep.ENTER_PASSCODE">
		<app-mobile-kamona-passcode-widget
				[title]="passcodeTimeline?.title"
				[totalStep]="timelines?.length"
				[currentStep]="PasscodeRecoveryStep.ENTER_PASSCODE"
				(emitSubmit)="setPasscode($event)"
				[version]="CustomTimelineVersion.version_8"
				[submitting]="submitting"
				[description]="passcodeTimeline?.description"
				(emitBack)="setCurrentStep(PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY)">
		</app-mobile-kamona-passcode-widget>
	</ng-container>
	<ng-container *ngSwitchCase="PasscodeRecoveryStep.CONFIRM_PASSCODE">
		<app-mobile-kamona-passcode-widget
		[title]="confirmPasscodeTimeline?.title"
		[totalStep]="timelines?.length"
		[currentStep]="confirmPasscodeTimeline?.step"
		(emitSubmit)="submitConfirmedPasscode($event)"
		[version]="CustomTimelineVersion.version_8"
		[submitting]="submitting"
		[description]="confirmPasscodeTimeline?.description"
		(emitBack)="setCurrentStep(PasscodeRecoveryStep.ENTER_PASSCODE)">
		</app-mobile-kamona-passcode-widget>
	</ng-container>
	<ng-container *ngSwitchCase="PasscodeRecoveryStep.PASSCODE_UPDATED">
		<app-mobile-kamona-message-modal (dismissModal)="dismiss()"
			[title]="SuccessTitle" [description]="SuccessDescription">
		</app-mobile-kamona-message-modal>
	</ng-container>
</ng-container>

<ng-template #stepOne>
	<ng-container *ngIf="usePhoneNumberForRecovery">
		<app-mobile-phone-number-recovery
				(emitBack)="goToLogin()"
				[defaultValue]="userTypePayload?.value"
				(emitSubmit)="handleRecovery(LoginTypeRequest.PHONENUMBER)"
				[submitting]="submitting"
				[timelines]="timelines">
		</app-mobile-phone-number-recovery>
	</ng-container>
	<ng-container *ngIf="!usePhoneNumberForRecovery">
		<app-mobile-forget-passcode-username-recovery
				(emitBack)="goToLogin()"
				(emitSubmit)="handleRecovery(LoginTypeRequest.USERNAME)"
				[defaultValue]="userTypePayload?.value"
				[submitting]="submitting"
				[timelines]="timelines">
		</app-mobile-forget-passcode-username-recovery>
	</ng-container>
</ng-template>

<ng-template #idVerification>
  <ng-container *ngIf="loading">
    <app-loading loadingText="Loading"></app-loading>
  </ng-container>
  <ng-container *ngIf="!loading">
    <ng-container *ngTemplateOutlet="liveliness"></ng-container>
    <ng-container *ngIf="!livelinessRequired">
      <app-mobile-kamona-otp-widget (emitBack)="setCurrentStep(PasscodeRecoveryStep.ENTER_PASSCODE_RECOVERY)"
        btnText="Next" (emitReload)="reloadOtp($event)" [ussd]="ussdCode" [submitting]="submitting"
        (emitSubmit)="handleOtpResponse($event)" [description]="otpTimeline?.description"
        [previousTitle]="otpTimeline?.previousTitle" [currentStep]="otpTimeline?.step" [totalStep]="timelines?.length"
        title="Verify Phone number" [currentOtpMode]="currentOTPMode || currentOtpModes?.SMS_MODE"
        [canUseWhatsappOTPResend]="useResendOtpViaWhatsapp"
        [canUseNewUssd]="canUseNewUssd"
        [hasResendButtonCountdown]="false"
        [canUseSmsOTPResend]="useResendOtpViaSms"
        [showBothCountDown]="showBothCountDown">
      </app-mobile-kamona-otp-widget>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #liveliness>
  <ng-container *ngIf="livelinessRequired">
		<ng-container>
			<app-mobile-kamona-liveliness-widget
				[submitting]="submitting"
				[flowId]="flowId"
				[metaMapReference]="reference"
				(emitCancel)="restart()"
				(emitBack)="restart()"
				[identityProvider]="provider"
				(emitFinishedMetamapVerification)="handleFinishedMetaMapVerification()"
				(emitFinishedSmileIDVerification)="submitSmileIDJob($event)">
			</app-mobile-kamona-liveliness-widget>
		</ng-container>
		<ng-container *ngIf="processVerification">
			<app-mobile-kamona-id-verification
				(emitVerifiedIdentity)="handleVerifiedIdentity($event)"
				(emitFailedIdentity)="handleFailedIdentity($event)"
				[verificationPayload]="verificationPayload"
				[verificationUrl]="idVerificationUrl">
			</app-mobile-kamona-id-verification>
		</ng-container>
	</ng-container>
</ng-template>

